export default "__VITE_ASSET__giAH4RrF__"